import { useState } from "react";
import { Sun, Moon } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ThemeToggle = () => {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  const toggle = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("empro_theme", next ? "dark" : "light");
  };
  return (
    <Button data-testid="theme-toggle" variant="ghost" size="icon" onClick={toggle}
      title={dark ? "Przełącz na tryb jasny" : "Przełącz na tryb ciemny"} className="h-9 w-9">
      {dark ? <Sun className="h-4 w-4 text-amber-400" /> : <Moon className="h-4 w-4 text-sky-500" />}
    </Button>
  );
};
